export enum PrimaryColorToken {
  primary25 = '#FFFAF5',
  primary50 = '#FFF7ED',
  primary100 = '#FFEDD5',
  primary200 = '#FDE2AB',
  primary300 = '#FEBB73',
  primary400 = '#FD923A',
  primary500 = '#FB7414',
  primary600 = '#EC590A',
  primary700 = '#C43F0A',
  primary800 = '#9C300C',
  primary900 = '#7E240B',
}

export default PrimaryColorToken

export type TPrimary =
  | 'primary25'
  | 'primary50'
  | 'primary100'
  | 'primary200'
  | 'primary300'
  | 'primary400'
  | 'primary500'
  | 'primary600'
  | 'primary700'
  | 'primary800'
  | 'primary900'
